export const formatDate = (date) => {
  if (!date) return "";

  const [year, month, day] = date.split("-");

  return new Date(year, month - 1, day).toLocaleDateString("es-AR", {
    day: "numeric",
    month: "long",
    year: "numeric",
  });
};

export const formatDateToInput = (date) => {
  if (!date) return "";

  const parsedDate = new Date(date);

  if (isNaN(parsedDate.getTime())) return "";

  return parsedDate.toISOString().split("T")[0];
};
